import { Link, useNavigate } from "react-router-dom";
import "../Styles/Feecategory.css";

export default function FeeCategoryTable() {
  const navigate = useNavigate();

  const handleNavigate = (categoryname) => {
    navigate(`/${categoryname}`);
  };

  const data = [
    { id: 1, categoryname: "Registration", categorytype: "Fee", amounttype: "Amount", applicableto: "New Students", categorystatus: "Active" },
    { id: 2, categoryname: "Re_registration", categorytype: "Fee", amounttype: "Amount", applicableto: "New Students", categorystatus: "Active" },
    { id: 3, categoryname: "Tution", categorytype: "Fee", amounttype: "Amount", applicableto: "All Students", categorystatus: "Active" },
    { id: 4, categoryname: "Library", categorytype: "Fee", amounttype: "Amount", applicableto: "All Students", categorystatus: "Active" },
    { id: 5, categoryname: "Miscellaneous", categorytype: "Fee", amounttype: "Amount", applicableto: "All Students", categorystatus: "Active" },
    { id: 6, categoryname: "Academic", categorytype: "Fee", amounttype: "Amount", applicableto: "All Students", categorystatus: "Active" },
    { id: 7, categoryname: "Book", categorytype: "Fee", amounttype: "Amount", applicableto: "All Students", categorystatus: "Active" },
    { id: 8, categoryname: "Uniform", categorytype: "Fee", amounttype: "Amount", applicableto: "All Students", categorystatus: "Active" },
    { id: 9, categoryname: "Sports", categorytype: "Fee", amounttype: "Amount", applicableto: "All Students", categorystatus: "Active" },
    { id: 10, categoryname: "E_learning", categorytype: "Fee", amounttype: "Amount", applicableto: "Selected Students", categorystatus: "Active" },
    { id: 11, categoryname: "Hostel Fees", categorytype: "Discount", amounttype: "Percentage", applicableto: "Selected Students", categorystatus: "Active" },
    { id: 12, categoryname: "Sibling", categorytype: "Discount", amounttype: "Percentage", applicableto: "Selected Students", categorystatus: "Active" },
    { id: 13, categoryname: "Staff", categorytype: "Discount", amounttype: "Percentage", applicableto: "All Students", categorystatus: "Active" },
    { id: 14, categoryname: "Scholorship", categorytype: "Discount", amounttype: "Percentage", applicableto: "New Students", categorystatus: "Active" },
    { id: 15, categoryname: "Full Payment", categorytype: "Discount", amounttype: "Percentage", applicableto: "All Students", categorystatus: "Active" },
    { id: 16, categoryname: "Non-Residence", categorytype: "Discount", amounttype: "Percentage", applicableto: "New Students", categorystatus: "Active" },
    { id: 17, categoryname: "Late Fee", categorytype: "Bonus", amounttype: "Amount", applicableto: "Selected Students", categorystatus: "Active" },
    { id: 18, categoryname: "Taxes", categorytype: "Bonus", amounttype: "Percentage", applicableto: "All Students", categorystatus: "Active" },
    { id: 19, categoryname: "Transfer Certificate", categorytype: "Fee", amounttype: "Amount", applicableto: "New Students", categorystatus: "Active" },
  ];

  return (
    <div className="category-container my-4">
      {/* Header */}
      <div className="special-header  d-flex justify-content-between">
        <h4 className="page-title pt-1">Fee Categories</h4>
        <Link to="/createfee" type="button" className="btn custom-btn pt-2">
          Create Fee Category
        </Link>
      </div>

      {/* Filters Section */}
      <div className="table-top-filters d-flex flex-wrap gap-3 ">
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="Search Category"
          style={{ maxWidth: "200px" }}
        />
        <select
          className="form-select form-select-sm"
          style={{ maxWidth: "200px" }}
        >
          <option>All</option>
          <option>Fee</option>
          <option>Discount</option>
          <option>Bonus</option>
        </select>
        <button type="button" className="btn custom-btn btn-sm">
          Clear
        </button>
      </div>

      {/* Table */}
      <div className="cardd shadow-sm">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>Sr No</th>
                  <th>Category Name</th>
                  <th>Category Type</th>
                  <th>Amount Type</th>
                  <th>Applicable To</th>
                  <th>Category Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row) => (
                  <tr key={row.id}>
                    <td>{row.id}</td>
                    <td>{row.categoryname}</td>
                    <td>{row.categorytype}</td>
                    <td>{row.amounttype}</td>
                    <td>{row.applicableto}</td>
                    <td>{row.categorystatus}</td>
                    <td>
                      <div className="btn-group">
                        <button
                          type="button"
                          className="btn btn-sm"
                          onClick={() => handleNavigate(row.categoryname)}
                          title="View"
                        >
                          <i className="bi bi-eye"></i>
                        </button>
                        <Link to="/createfee"
                          type="button"
                          className="btn btn-sm"
                          title="Edit"
                        >
                          <i className="bi bi-pencil-square"></i>
                        </Link>
                        <button
                          type="button"
                          className="btn btn-sm"
                          onClick={() => handleNavigate(row.categoryname)}
                          title="Delete"
                        >
                          <i className="bi bi-trash3"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
